import { render, staticRenderFns } from "./marketingInvitationShow.vue?vue&type=template&id=5ab77254&scoped=true&"
import script from "./marketingInvitationShow.vue?vue&type=script&lang=js&"
export * from "./marketingInvitationShow.vue?vue&type=script&lang=js&"
import style0 from "./marketingInvitationShow.vue?vue&type=style&index=0&id=5ab77254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab77254",
  null
  
)

export default component.exports